import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

export type AppDispatch = ThunkDispatch<never, unknown, UnknownAction>;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector;

export function useStateReader<S, T>(selector: (state: S) => T): () => T {
  const store = useStore<S>();

  return useCallback(() => selector(store.getState()), [store, selector]);
}
